export default __webpack_public_path__ + "static/media/mic.d6933417.svg";